import type {ScanContext} from "../../scan-model/ScanContext.tsx";
import type {OrchestrationJob} from "../../../../metl-models/jobs/Orchestration.ts";
import type {TransformationJob} from "../../../../metl-models/jobs/Transformation.ts";
import type {JobTypeString} from "./JobDownloadStrategy.ts";
import {problemIndicatorHolder, type ScannedJobProblemIndicators} from "./ProblemIndicators.ts";
import {getComponentsOfType} from "../../../../metl-models/jobs/component-types/jobComponentTypeFinder.ts";
import {runJobComponent} from "../../../../metl-models/jobs/component-types/runJobComponent.ts";
import {getName} from "../../../../metl-models/jobs/JobObjectHelper.ts";
import {pythonComponent} from "../../../../metl-models/jobs/component-types/pythonComponent.ts";
import {databaseQueryComponent} from "../../../../metl-models/jobs/component-types/dbQuery.ts";
import {containsStringPassword} from "../../../../metl-models/jobs/parameter/PasswordParameterScanner.ts";

export interface ScannedJobResult {
    problemIndicators?: ScannedJobProblemIndicators
    componentCount: Record<number, number>
    jobName: string,
    jobType: JobTypeString
    linksTo: string[]
    debug: OrchestrationJob | TransformationJob
}

export function scanJobDetails(ctx: ScanContext, jobDebug: OrchestrationJob | TransformationJob, jobType: JobTypeString, jobName: string): ScannedJobResult {
    const problemHolder = problemIndicatorHolder()
    const linksTo = getComponentsOfType(jobDebug, runJobComponent)

    const components = Object.values(jobDebug.components)

    components
        .filter(component => ctx.sharedJobs[component.implementationID] !== undefined)
        .forEach(component => problemHolder.addSharedJob(getName(component), ctx.sharedJobs[component.implementationID]!))

    getComponentsOfType(jobDebug, pythonComponent).forEach(problemHolder.addPython)
    getComponentsOfType(jobDebug, databaseQueryComponent).forEach(problemHolder.addDBQuery)

    components
        .filter(component => Object.values(component.gridExportMappings ?? {}).length > 0)
        .forEach(component => {
            problemHolder.addGridExportComponent(getName(component))
        })

    components.forEach((component) => {
        if (containsStringPassword(component))
            problemHolder.markStringPassword(getName(component))
    })

    const componentCount: Record<number, number> = {}
    Object.values(jobDebug.components).forEach(component => {
        const existingCount = componentCount[component.implementationID] ?? 0
        componentCount[component.implementationID] = existingCount + 1
    })

    const result: ScannedJobResult = {
        problemIndicators: problemHolder.resolve(),
        linksTo: linksTo.map(runJobComponent => runJobComponent.targetJobName),
        jobName,
        jobType,
        componentCount,
        debug: jobDebug
    }

    return result
}